import { _initialState } from './_initialState';
import {
  updateAllPromoProducts
} from './actions';
import addPromoProducts from './actions/addPromoProducts';

export const groupedPromoStore = (set, get) => ({
  ..._initialState,
  updateAllPromoProducts: (data) => updateAllPromoProducts(set, data),
  addPromoProducts: (promoProductsToAdd) => addPromoProducts(set, get, promoProductsToAdd)
});
